 const firebaseConfig = {
  apiKey: "AIzaSyBBJutfQyeKcpXzBMtwnR-oVfjE52k1ycg",
  authDomain: "e-restaurant-27e3c.firebaseapp.com",
  databaseURL: "https://e-restaurant-27e3c.firebaseio.com",
  projectId: "e-restaurant-27e3c",
  storageBucket: "e-restaurant-27e3c.appspot.com",
  messagingSenderId: "775972226674",
  appId: "1:775972226674:web:38e8b11db66079c1a1e4eb",
  measurementId: "G-YV97PHHLX1"
};
export const STRIPE_APIKEY = `pk_test_Oo2HHpANmwwZboKUf7S5z9Gf00i0PqRRBD`;
export default firebaseConfig;